// extracted by mini-css-extract-plugin
export default {"mainCont":"ComingSoon_mainCont__crxCr"};